import { render, staticRenderFns } from "./GroupPatrimonial.vue?vue&type=template&id=766e636c&"
import script from "./GroupPatrimonial.vue?vue&type=script&lang=js&"
export * from "./GroupPatrimonial.vue?vue&type=script&lang=js&"
import style0 from "./GroupPatrimonial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports